import React from 'react';
import { Dropdown, DropdownButton, InputGroup } from 'react-bootstrap';
import { Field } from 'formik';
import PropTypes from 'prop-types';

export const Price = ({ values, setValues, errors, touched }) => (
  <div>
    <label>Precio de la propiedad *</label>
    <InputGroup size="sm" className="formWidths" style={{ maxWidth: '150px' }}>
      <DropdownButton
        variant="secondary"
        defaultValues={values.price?.currency}
        id="input-group-dropdown-1"
        menuVariant="dark"
        size="lg"
        title={values.price?.currency === 1 ? 'USD' : 'ARS'}
      >
        <Dropdown.Item
          onClick={e =>
            setValues(prev => ({
              ...prev,
              price: {
                ...prev.price,
                currency: parseInt(e.target.id)
              }
            }))
          }
          id={1}
        >
          USD
        </Dropdown.Item>
        <Dropdown.Item
          onClick={e =>
            setValues(prev => ({
              ...prev,
              price: {
                ...prev.price,
                currency: parseInt(e.target.id)
              }
            }))
          }
          id={2}
        >
          ARS
        </Dropdown.Item>
      </DropdownButton>

      <Field className="form-control" name="price.total" />
      {errors.price?.total && touched.price?.total && (
        <label className="w-100 text-danger mt-1">{errors.price.total}</label>
      )}
    </InputGroup>
  </div>
);

Price.propTypes = {
  values: PropTypes.object,
  setValues: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
